import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { OrderProposalService } from "../../../services/api/order-proposal.service";
import { OrderProposalActions } from "../../actions/order-proposal.actions";

@Injectable()
export class DeclineOrderProposalEffects {
	proposalDeclinedRequested = createEffect(() => {
		return this.actions.pipe(
			ofType(OrderProposalActions.denyProposal.deny),
			switchMap((action) => {
				return this.orderProposalService.denyProposal(action.id, action.body).pipe(
					map(() => OrderProposalActions.denyProposal.denySuccess({ id: action.id })),
					catchError((error) => of(OrderProposalActions.denyProposal.denyFail({ error })))
				);
			})
		);
	});

	constructor(
		private actions: Actions,
		private orderProposalService: OrderProposalService
	) {}
}
